<div class="calculator-result" *ngIf="contents && directDebitBenefitData">
    <div class="title-wrapper" [ngStyle]="{ background: bgImg }">
        <h1>{{ contents.wwyg.header }}</h1>
        <h2>{{ contents.wwyg.subHeader }}</h2>
    </div>
    <div class="content">
        <div class="main-title">
            <img [src]="contents.wwyg.image" alt="" class="gift" />
            <h2>{{ contents.wwyg.textImage }}</h2>
        </div>
        <div class="results-wrapper">
            <div *ngFor="let card of directDebitBenefitData.userCards; let i = index">
                <div class="result">
                    <div class="sum-wrapper">
                        <div class="only-sum" [ngClass]="{ text: card.benefitNum && card.benefitNum !== ''}">
                            <span *ngIf="card.benefitNum && card.benefitNum !== ''" class="such">כ-</span>
                            <span class="sum">
                                <span *ngIf="(card.isMaxBack || card.isCrypto) && card.benefitNum !== ''" class="shekel">₪</span>
                                <span>{{ card.benefitNum.trim() }}</span>
                            </span>
                        </div>
                        <div class="sum-text-wrapper">
                            <span class="sum-text" [attr.id]="'sum-text' + i" [ngClass]="{textCenterMarginBotton: !card.benefitNum || card.benefitNum == ''}">
                                <span [innerHTML]="card.benefitDesc"></span>
                                <span
                                    class="result-tip"
                                    appTooltip
                                    [tooltipText]="card.tooltipText"
                                    [tooltipHtmlParent]="'sum-text' + i"
                                ></span>
                            </span>

                            <span *ngIf="card.isPinukim" class="sum-text"> וגם מאפשר לך לצבור פינוקים </span>
                        </div>
                    </div>
                    <div class="card-type">
                        <img [src]="card.cardImage" alt="" class="card-img" [ngClass]="{textCenterMarginTop: !card.benefitNum || card.benefitNum == '', textCenterMarginTopIsPinokim: card.benefitNum && card.benefitNum !== ''}" />
                        <div class="card-info">
                            <span class="num">{{ card.shortCardNumber }}</span>
                            <span class="type">{{ card.cardName }}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="i < directDebitBenefitData.userCards.length - 1" class="or">
                    <span>או</span>
                </div>
            </div>
        </div>
        <h3>שווה להעביר הוראות קבע לכרטיס M_A_X !</h3>
        <div class="button-wrapper">
            <a (click)="goToTransfer()" class="brand-button green-button long-text-button" title=""
                ><span>בואו נעביר את הוראות הקבע</span></a
            >
        </div>
    </div>
    <div class="terms">
        <p>
            {{ contents.wwyg.asterix }}
        </p>
    </div>
</div>
